import { useCallback, useState } from "react";

import { ForgotUIProps } from "./Forgot.types.tsx";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

export const useForgot = (): ForgotUIProps => {
  const { onForgot } = useLoginContext();

  const [email, setEmail] = useState("");
  const [validated, setValidated] = useState(false);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  }, []);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      const form = e.currentTarget;
      const isValid = form.checkValidity();
      setValidated(true);

      if (!isValid) return;

      await onForgot(email);
    },
    [email, onForgot]
  );

  return {
    email,
    validated,
    handleChange,
    handleSubmit,
  };
};
